/**
 * #36221: "Refund credit card fee" on the cancellation form.
 *
 * A card-paid mutual policy carries an annualized `credit_card` processing-fee line. On cancellation
 * the backend keeps that fee for the card payments the member already made (it is Branch's real
 * Stripe cost) and drops it for the installments that will never be charged; ticking the checkbox
 * refunds it to the member instead. The checkbox is only shown when the policy carries the line, and
 * its initial state comes from the brand config so each mutual can pick its own default.
 */
import { isImportedPolicy } from 'core/helpers/policy-status';

export const policyHasCreditCardFee = (fees) =>
  Array.isArray(fees) && fees.some((fee) => fee?.type === 'credit_card' && Number(fee?.amount) > 0);

export const defaultRefundCreditCardFee = (brandAppConfig) =>
  brandAppConfig?.refundCreditCardFeeOnCancellationByDefault === true;

// An original imported term's fee line is offset by the import-time credit (#35705) and the backend
// leaves it whole regardless of the checkbox, so don't offer a choice that would be ignored.
export const showRefundCreditCardFeeCheckbox = ({ fees, policy }) =>
  policyHasCreditCardFee(fees) && !isImportedPolicy(policy);
